import { showNotification } from '@mantine/notifications';

/**
 * 生成csv文件
 *
 * @param fileName 文件名称
 * @param header 创建CSV的头部行
 * @param rows将每个数据对象转换为CSV格式的一行
 */

export const generateCSV = (fileName: string, data: { header: string[]; rows: string[][] }): void => {
  try {
    const { header, rows } = data;

    // 用于转义字段中的特殊字符的函数
    const escapeField = (field: string): string => {
      if (field.includes('"')) {
        field = field.replace(/"/g, '""');
      }
      // 包裹在双引号内，以处理字段中的逗号和换行符
      return `"${field}"`;
    };

    // 将头部行和数据行合并成一个二维数组，然后转换为CSV格式的字符串
    const csvArray: string[][] = [header.map((h) => h.trim())].concat(
      rows.map((row) => row.map((cell) => String(cell).trim()))
    );
    const csvString: string = csvArray.map((row) => row.map(escapeField).join(',')).join('\n');

    // UTF-8的BOM
    const BOM = '\uFEFF';

    console.log('csvString', csvString);
    // 创建一个Blob对象，它是一个可以存储大量二进制数据的对象
    // 在csvString前添加BOM
    const blob: Blob = new Blob([BOM + csvString], { type: 'text/csv;charset=utf-8;' });

    // 创建一个链接，它指向Blob对象，然后通过这个链接下载文件
    const url: string = URL.createObjectURL(blob);

    // 创建一个“a”标签，用于触发下载
    const link: HTMLAnchorElement = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', fileName + '.csv');

    // 将“a”标签插入到页面中，然后模拟点击，以开始下载
    document.body.appendChild(link);
    link.click();

    // 清理：删除“a”标签和释放URL对象
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error generating CSV file:', error);
    showNotification({ message: JSON.stringify(error), color: 'red' });
  }
};

/**
 * 去掉后缀获取文件名
 *
 * @param fileName 文件名称
 */
export const getFilenameWithoutExtension = (filename: string): string => {
  const lastDotIndex = filename.lastIndexOf('.');

  if (lastDotIndex === -1 || lastDotIndex === 0) {
    return filename;
  }

  return filename.substring(0, lastDotIndex);
};
